import React from "react";

import { ClassOverviewPage } from "@harrow-education/ui-components";

const ClassOverview = (props) => {
  return <ClassOverviewPage {...props} />;
};

export default ClassOverview;
